<template>
  <div class="pkg-hero">
    <div class="container text-center">
      <img src="/img/logopriadi.png" class="pkg-hero-logo" alt="PRiADI logo" />
    </div>
  </div>

  <div class="pkg-carousel-wrap">
    <div class="pkg-carousel d-flex overflow-scroll hide-scrollbar gap-3">
      <div class="pkg-carousel-card">
        <img src="/img/slide-home/scientific-objective.webp" class="pkg-carousel-icon" alt="" />
        <p class="pkg-carousel-title">{{ $t('carousel.scientificObjective') }}</p>
        <p class="pkg-carousel-desc">{{ $t('carousel.scientificObjectiveDesc') }}</p>
      </div>
      <div class="pkg-carousel-card">
        <img src="/img/slide-home/bias-free.webp" class="pkg-carousel-icon" alt="" />
        <p class="pkg-carousel-title">{{ $t('carousel.biasFree') }}</p>
        <p class="pkg-carousel-desc">{{ $t('carousel.biasFreeDesc') }}</p>
      </div>
      <div class="pkg-carousel-card">
        <img src="/img/slide-home/all-ages.webp" class="pkg-carousel-icon" alt="" />
        <p class="pkg-carousel-title">{{ $t('carousel.allAges') }}</p>
        <p class="pkg-carousel-desc">{{ $t('carousel.allAgesDesc') }}</p>
      </div>
      <div class="pkg-carousel-card">
        <img src="/img/slide-home/very-comprehensive.webp" class="pkg-carousel-icon" alt="" />
        <p class="pkg-carousel-title">{{ $t('carousel.veryComprehensive') }}</p>
        <p class="pkg-carousel-desc">{{ $t('carousel.veryComprehensiveDesc') }}</p>
      </div>
      <div class="pkg-carousel-card">
        <img src="/img/slide-home/easy-to-understand.png" class="pkg-carousel-icon" alt="" />
        <p class="pkg-carousel-title">{{ $t('carousel.easyToUnderstand') }}</p>
        <p class="pkg-carousel-desc">{{ $t('carousel.easyToUnderstandDesc') }}</p>
      </div>
      <div class="pkg-carousel-card">
        <img src="/img/slide-home/multi-language.webp" class="pkg-carousel-icon" alt="" />
        <p class="pkg-carousel-title">{{ $t('carousel.multiLanguages') }}</p>
        <p class="pkg-carousel-desc">{{ $t('carousel.multiLanguagesDesc') }}</p>
      </div>
    </div>
  </div>

  <div class="container pkg-body">
    <div class="tabs-priadi mb-3">
      <button class="tab-priadi" :class="{ active: activeTab === 'packages' }" @click="activeTab = 'packages'">
        {{ $t('testPackage') }}
      </button>
      <button class="tab-priadi" :class="{ active: activeTab === 'promo' }" @click="activeTab = 'promo'">
        {{ $t('promo') }}
      </button>
    </div>

    <div v-if="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="activeTab === 'packages' && !isLoading">
      <div v-if="get_subcategory.length === 0" class="empty-state">
        <i class="bi bi-box-seam empty-state-icon"></i>
        <p class="empty-state-title">No packages available</p>
        <p class="empty-state-desc">Check back later for new test packages.</p>
      </div>

      <button
        v-for="(subcategory, index) in get_subcategory"
        :key="subcategory.id || index"
        class="pkg-card w-100 text-start mb-3"
        @click="openDetail(index)">
        <span class="pkg-name">{{ subcategory.name }}</span>
        <span class="pkg-target">{{ subcategory.grouping }}</span>
        <span class="pkg-consultation" v-if="subcategory.is_consultation === '1'"> + {{ $t('freeConsult') }} </span>
        <div class="pkg-card-foot">
          <span class="pkg-price">{{ formatPrice(subcategory.price) }}</span>
          <span class="btn-priadi pkg-card-cta">{{ $t('selectPackage') }} <i class="bi bi-arrow-right"></i></span>
        </div>
      </button>
    </div>

    <div v-if="activeTab === 'promo' && !isLoading">
      <button
        v-for="(promo, index) in get_promo"
        :key="promo.id || index"
        class="pkg-card w-100 text-start mb-3"
        @click="openDetail(index, 'yes')">
        <span class="pkg-name">{{ promo.name }}</span>
        <span class="pkg-target">{{ promo.grouping }}</span>
        <span class="pkg-consultation" v-if="promo.is_consultation === '1'"> + {{ $t('freeConsult') }} </span>
        <div class="pkg-card-foot">
          <div>
            <s class="pkg-price-original">{{ formatPrice(promo.price_real) }}</s>
            <span class="pkg-price">{{ formatPrice(promo.price) }}</span>
          </div>
          <span class="btn-priadi pkg-card-cta">{{ $t('selectPackage') }} <i class="bi bi-arrow-right"></i></span>
        </div>
      </button>

      <div class="card-priadi mt-3">
        <p class="h5 mb-1">{{ $t('promo') }}</p>
        <p class="pkg-voucher-desc">{{ $t('voucherCodeText') }}</p>

        <div v-if="promoError" class="alert-priadi alert-priadi-danger mb-3" role="alert">
          {{ promoError }}
        </div>

        <div v-if="promoSuccess" class="alert-priadi alert-priadi-success mb-3" role="alert">
          {{ promoSuccess }}
        </div>

        <form @submit.prevent="select_promo(referral_code)">
          <input
            type="text"
            v-model="referral_code"
            class="form-control-priadi w-100 mb-2"
            :placeholder="$t('voucherCodeHint')"
            aria-label="Voucher code" />
          <button type="submit" class="btn-priadi btn-priadi-block">
            {{ $t('submit') }}
          </button>
        </form>
      </div>
    </div>
  </div>

  <BottomNav />

  <div
    class="modal fade"
    :class="{ show: showLoginModal }"
    :style="{ display: showLoginModal ? 'block' : 'none' }"
    tabindex="-1"
    role="dialog"
    aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content pkg-modal">
        <div class="pkg-modal-header">
          <img src="/img/logopriadi_blue.png" class="pkg-modal-logo" alt="PRiADI logo" />
          <h2 class="pkg-modal-title">{{ $t('loginModal.title') }}</h2>
          <p class="pkg-modal-subtitle">{{ $t('loginModal.subtitle') }}</p>
        </div>
        <div class="pkg-modal-body">
          <button class="btn-priadi btn-priadi-block mb-2" @click="handleSignIn">
            <i class="bi bi-box-arrow-in-right me-2"></i>{{ $t('signin') }}
          </button>
          <button class="btn-priadi-outline btn-priadi-block py-2" @click="handleRegister">
            <i class="bi bi-person-plus me-2"></i>{{ $t('signup') }}
          </button>
          <div class="pkg-modal-divider">
            <span>{{ $t('or') }}</span>
          </div>
          <button class="pkg-modal-guest" @click="handleGuestAccess">{{ $t('continueAsGuest') }} <i class="bi bi-arrow-right"></i></button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" :class="{ show: showLoginModal }" :style="{ display: showLoginModal ? 'block' : 'none' }"></div>
</template>

<script>
import BottomNav from '../components/BottomNav'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    BottomNav,
  },
  data() {
    return {
      activeTab: 'packages',
      referral_code: '',
      get_subcategory: [],
      get_promo: [],
      showLoginModal: false,
      isLoading: false,
      promoError: '',
      promoSuccess: '',
    }
  },
  created() {
    this.fetchPackages()
  },
  methods: {
    formatPrice(price) {
      return 'Rp.' + Intl.NumberFormat('id').format(price) + ',-'
    },
    fetchPackages() {
      this.isLoading = true
      axios
        .get('https://api.priadi.id/api/list_report', {
          headers: { 'x-api-key': process.env.VUE_APP_PRIADI_API_KEY },
        })
        .then((response) => {
          this.get_subcategory = response.data.list_report.sort((a, b) => a.price - b.price)
        })
        .catch((error) => {
          console.error('Failed to load packages:', error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    select_promo(referral_code) {
      this.promoError = ''
      this.promoSuccess = ''

      if (!referral_code || referral_code.trim() === '') {
        this.promoError = this.$t('invalidReferralCode')
        return
      }

      axios
        .get('https://api.priadi.id/api/list_report', {
          params: { reff_code: referral_code },
          headers: { 'x-api-key': process.env.VUE_APP_PRIADI_API_KEY },
        })
        .then((response) => {
          const promoData = response.data.list_report.sort((a, b) => a.price - b.price)

          let hasDiscount = false
          if (promoData && promoData.length > 0) {
            for (let i = 0; i < promoData.length; i++) {
              if (promoData[i].price < promoData[i].price_real) {
                hasDiscount = true
                break
              }
            }
          }

          if (!hasDiscount) {
            this.promoError = this.$t('referralCodeError')
            this.get_promo = []
            this.referral_code = ''
          } else {
            this.get_promo = promoData
            this.promoSuccess = this.$t('codeApplied')
            this.referral_code = ''
          }
        })
        .catch((error) => {
          console.error('Promo code error:', error)
          this.promoError = this.$t('codeInvalid')
          this.get_promo = []
          this.referral_code = ''
        })
    },
    openDetail(index, isPromo = 'no') {
      const item = isPromo === 'no' ? this.get_subcategory[index] : this.get_promo[index]
      if (!item) return
      if (isPromo !== 'no') {
        item.voucher_code = this.referral_code
      }
      this.$store.dispatch('setPackage', item)
      this.$router.push({ name: 'Package Detail' })
    },
    handleSignIn() {
      this.showLoginModal = false
      this.$router.push('/auth')
    },
    handleRegister() {
      this.showLoginModal = false
      this.$router.push('/register')
    },
    handleGuestAccess() {
      this.showLoginModal = false
    },
  },
  mounted() {
    document.body.classList.add('body-tinted')
    if (!this.$store.getters.isAuth) {
      this.showLoginModal = true
    }
  },
  unmounted() {
    document.body.classList.remove('body-tinted')
  },
}
</script>

<style scoped>
/* Hero — the fingerprint is PRiADI's thesis */
.pkg-hero {
  background: var(--color-primary) url('/img/fpimageup.png');
  background-size: cover;
  background-position: center;
  padding: var(--space-8) var(--space-4) var(--space-16);
}

.pkg-hero-logo {
  margin-left: auto;
  margin-right: auto;
  width: 180px;
}

/* Carousel — overlaps hero for depth */
.pkg-carousel-wrap {
  margin-top: -2.5rem;
  position: relative;
  z-index: 1;
  padding: 0 var(--space-4);
}

.pkg-carousel {
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding: var(--space-2) 0;
}

.pkg-carousel-card {
  flex: 0 0 75%;
  min-width: 0;
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  scroll-snap-align: start;
}

.pkg-carousel-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-bottom: var(--space-3);
}

.pkg-carousel-title {
  font-size: var(--text-base);
  font-weight: var(--font-semibold);
  color: var(--color-text-primary);
  margin-bottom: var(--space-1);
}

.pkg-carousel-desc {
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  line-height: var(--leading-normal);
  margin-bottom: 0;
}

/* Body content */
.pkg-body {
  padding-top: var(--space-6);
  padding-bottom: var(--space-16);
}

/* Package card — soft gradient top */
.pkg-card {
  display: block;
  background: linear-gradient(
    to bottom,
    rgba(var(--color-primary-rgb), 0.08) 0%,
    rgba(var(--color-primary-rgb), 0.09) 40%,
    var(--color-surface) 100%
  );
  border: none;
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  font-family: var(--font-family);
  transition: transform var(--transition-base), box-shadow var(--transition-base);
}

.pkg-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.pkg-card:active {
  transform: scale(0.98);
}

.pkg-card:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.pkg-card-foot {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: var(--space-3);
  gap: var(--space-3);
}

.pkg-card-cta {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: var(--text-sm);
  padding: var(--space-1) var(--space-3);
}

.pkg-voucher-desc {
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  margin-bottom: var(--space-4);
}

/* Login modal — branded, not generic */
.pkg-modal {
  border-radius: var(--radius-lg);
  border: none;
  box-shadow: var(--shadow-lg);
  margin: var(--space-4);
  overflow: hidden;
}

.pkg-modal-header {
  background: linear-gradient(160deg, rgba(var(--color-primary-rgb), 0.08) 0%, rgba(var(--color-primary-rgb), 0.02) 100%);
  padding: var(--space-8) var(--space-6) var(--space-6);
  text-align: center;
}

.pkg-modal-logo {
  width: 72px;
  margin-bottom: var(--space-4);
  margin-left: auto;
  margin-right: auto;
}

.pkg-modal-title {
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--space-2);
}

.pkg-modal-subtitle {
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  line-height: var(--leading-normal);
  margin-bottom: 0;
}

.pkg-modal-body {
  padding: var(--space-6);
}

.pkg-modal-divider {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin: var(--space-4) 0;
}

.pkg-modal-divider::before,
.pkg-modal-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: var(--color-border);
}

.pkg-modal-divider span {
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.pkg-modal-guest {
  background: none;
  border: none;
  width: 100%;
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  font-family: var(--font-family);
  cursor: pointer;
  transition: color var(--transition-base);
}

.pkg-modal-guest:hover {
  color: var(--color-primary);
}
</style>
